import { render, staticRenderFns } from "./ReviewsCategoriesTableHeader.vue?vue&type=template&id=3964937a&scoped=true&"
import script from "./ReviewsCategoriesTableHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesTableHeader.vue?vue&type=style&index=0&id=3964937a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964937a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
